import React from 'react';
import styled from 'styled-components/macro';

export const TextAreaStyles = styled.textarea`
  height: 100%;

  background: #ffffff;

  border: 1px solid #d0d3d9;
  border-radius: 4px;

  width: 100%;
  padding: 9px 20px 9px 12px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  box-sizing: border-box;
  color: #334144;
`;
export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  flex-direction: column;
  .error {
    border-color: red;
  }
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  color: #9297a2;
`;

export interface CustomTextAreaProps {
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  name: string;
  id?: string;
  label?: string;
  placeholder?: string;
  isError: boolean;
  rows?: number;
}

export const TextArea = (props: CustomTextAreaProps) => {
  return (
    <FormGroup>
      {props.label && (
        <Label htmlFor={props.id || props.name}>{props.label}</Label>
      )}
      <TextAreaStyles {...props} className={props.isError ? 'error' : ''} />
    </FormGroup>
  );
};
